var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"/prayer_hands_gray.png","alt":"pray"}})
}
var staticRenderFns = []

export { render, staticRenderFns }